module.exports = __webpack_public_path__ + "static/img/why-us1.613641d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/why-us1.jpg
// module id = 244
// module chunks = 1